var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4584 16.625H8.13836C6.85586 16.625 5.62877 16.0788 4.77377 15.1367L1.97919 12.065C0.64919 10.6083 0.64919 8.4075 1.97919 6.94292L4.77377 3.87125C5.62877 2.92125 6.85586 2.375 8.13836 2.375H13.4584C15.9679 2.375 18.0104 4.4175 18.0104 6.92708V12.0729C18.0104 14.5825 15.9679 16.625 13.4584 16.625ZM8.13836 3.5625C7.19627 3.5625 6.28586 3.96625 5.65252 4.66292L2.85002 7.7425C1.93961 8.74792 1.93961 10.26 2.85002 11.2654L5.64461 14.3371C6.27794 15.0338 7.18836 15.4375 8.13044 15.4375H13.4584C15.3109 15.4375 16.8229 13.9254 16.8229 12.0729V6.92708C16.8229 5.07458 15.3109 3.5625 13.4584 3.5625H8.13836Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 12.0492C12.5163 12.0492 12.3658 11.9937 12.2471 11.875L8.33625 7.95624C8.10667 7.72666 8.10667 7.34666 8.33625 7.11707C8.56583 6.88749 8.94583 6.88749 9.17542 7.11707L13.0863 11.0358C13.3158 11.2654 13.3158 11.6454 13.0863 11.875C12.9675 11.9937 12.8171 12.0492 12.6667 12.0492Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75583 12.0492C8.60542 12.0492 8.455 11.9938 8.33625 11.875C8.10667 11.6454 8.10667 11.2654 8.33625 11.0358L12.2471 7.12501C12.4767 6.89542 12.8567 6.89542 13.0863 7.12501C13.3158 7.35459 13.3158 7.73459 13.0863 7.96417L9.17542 11.875C9.05667 11.9938 8.90625 12.0492 8.75583 12.0492Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.a77616cd640b7419f9c8a1e881a1b359.svg";
export { ForwardRef as ReactComponent };